// Tiny global pause on heavy impacts. Provides a timeScale used by Renderer & SlowMo.
import { CONFIG } from '../config';

export class HitStop {
  private remaining = 0;
  trigger(strength: number): void {
    if (strength < 8) return;
    const ms = Math.min(140, CONFIG.fx.hitstopMs * Math.min(2, strength * 0.05));
    this.remaining = Math.max(this.remaining, ms / 1000);
  }
  step(realDt: number): void {
    this.remaining = Math.max(0, this.remaining - realDt);
  }
  factor(): number { return this.remaining > 0 ? 0 : 1; }
  reset(): void { this.remaining = 0; }
}
